import { FadeInUp } from '../animations';

const whyIndia = [
  'Diverse Manufacturing Ecosystem',
  'Competitive Production',
  'Multiple Product Categories',
  'Skilled Manufacturing Clusters',
  'Custom Product Development',
  'Export-Oriented Supply Base',
];

const WhyIndiaSection = () => (
  <section className="py-24 lg:py-32 bg-[#fafaf9]" data-testid="why-india-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <FadeInUp className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0B2A57] mb-4" style={{ fontFamily: 'Cabinet Grotesk' }}>
          WHY SOURCE FROM INDIA?
        </h2>
      </FadeInUp>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {whyIndia.map((item, i) => (
          <FadeInUp key={item} delay={i * 0.08}>
            <div className="p-6 bg-white border border-[#E5E0D8]/60">
              <div className="w-8 h-px bg-[#0B2A57] mb-4" />
              <h3 className="text-sm font-semibold tracking-wider uppercase text-[#0B2A57]">{item}</h3>
            </div>
          </FadeInUp>
        ))}
      </div>
    </div>
  </section>
);

export default WhyIndiaSection;
